import { ref } from 'vue'
import apiService from '../apiService.js'

export function useSpotifyService() {
  const loading = ref(false)
  const error = ref(null)
  
  const lookupAlbum = async (spotifyId) => {
    loading.value = true
    error.value = null
    
    try {
      // Validate Spotify ID format
      if (!spotifyId || spotifyId.length !== 22) {
        throw new Error('Invalid Spotify ID format. Please enter a 22-character ID.')
      }
      
      const response = await apiService.getSpotifyAlbum(spotifyId)
      return response
    } catch (err) {
      let errorMessage = 'Failed to lookup album on Spotify'
      
      // Handle different error types
      if (err.message.includes('Invalid Spotify ID')) {
        errorMessage = err.message
      } else if (err.response?.status === 404) {
        errorMessage = 'Album not found on Spotify. Please check the ID and try again.'
      } else if (err.response?.status === 429) {
        errorMessage = 'Too many requests. Please wait a moment and try again.'
      } else if (err.response?.status >= 500) {
        errorMessage = 'Spotify service is temporarily unavailable. You can enter album details manually.'
      } else if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
        errorMessage = 'Request timed out. Please check your connection and try again.'
      } else if (err.message.includes('Network Error')) {
        errorMessage = 'Network error. Please check your connection and try again.'
      }
      
      error.value = errorMessage
      throw new Error(errorMessage)
    } finally {
      loading.value = false
    }
  }
  
  return { loading, error, lookupAlbum }
}